export enum SocketPathEnum {
  MEASSAGES_PATH = '/messages/',
  CONTACTS_PATH = '/contacts/',
  ATTENDANCE_PATH = '/attendance/',
}